import React from 'react';

export const NotFoundError = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="error-label">⚠️ Error</div>
        <h1>Page not found</h1>
        <p>Sorry!, the page you are looking for does not exist or has been removed.</p>
        <button className='go-backmenu'onClick={() => window.history.back()}>← Go back</button>
      </div>
    </div>
  );
};
